import { render } from "./SelectInput.vue?vue&type=template&id=15ec1d6f&scoped=true&ts=true"
import script from "./SelectInput.vue?vue&type=script&lang=ts"
export * from "./SelectInput.vue?vue&type=script&lang=ts"

import "./select-input.scss?vue&type=style&index=0&id=15ec1d6f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ec1d6f"]])

export default __exports__